import { render, staticRenderFns } from "./lookReport.vue?vue&type=template&id=2c140ac9&scoped=true"
import script from "./lookReport.vue?vue&type=script&lang=js"
export * from "./lookReport.vue?vue&type=script&lang=js"
import style0 from "./lookReport.vue?vue&type=style&index=0&id=2c140ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c140ac9",
  null
  
)

export default component.exports